import React from "react";
import { useSelector } from "react-redux";
import moment from "moment";
import { timeConvert } from "../Branches/ContactPageTools";

const PreviousOrderAgainCard = ({ order, handleReorder, themeColor }) => {
  const settings = useSelector((state) => state.store.store.settings);
  const language = useSelector((state) => state.store.language);
  const currency =
    language === "english"
      ? settings.base_currency
      : settings.base_currency_local;
  const showOnlyFirst20Letters = (string) => {
    if ((string || "").length > 20) {
      return string.substring(0, 20) + "...";
    } else {
      return string;
    }
  };

  const currencyAndTimeInfo = `${parseFloat(order.total).toFixed(
    settings.base_currency_decimals
  )} ${currency} - ${moment(order.created, "YYYY-MM-DD").format(
    language === "english" ? "DD/MMM" : "MM/DD"
  )} ${timeConvert(moment(order.created).format("HH:mm:ss"), language)}`;

  return (
    <div
      style={{
        width: 300,
        height: 100,
        backgroundColor: "#fff",
        border: "1px solid  #F5F5F5",
        borderRadius: 5,
        marginRight: 8,
        display: "flex",
        flexDirection: language === "arabic" ? "row-reverse" : "row",
        padding: 8,
      }}
    >
      <div
        style={{
          flex: "0 0 60%",
          textAlign: language === "arabic" ? "right" : "left",
          direction: language === "arabic" ? "rtl" : "ltr",
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
        }}
      >
        <div>
          <p
            style={{
              fontSize: 12,
              fontWeight: 700,
              fontFamily: "Quicksand",
              margin: 0,
            }}
          >
            <span
              style={{
                color: themeColor,
              }}
            >
              {order.items[0]?.quantity}x{" "}
            </span>
            {showOnlyFirst20Letters(
              language === "arabic"
                ? order.items[0]?.product.ar_name
                : order.items[0]?.product.name
            )}
          </p>
          {order.items.length > 1 && (
            <p
              style={{
                fontSize: 12,
                fontWeight: 700,
                fontFamily: "Quicksand",
                margin: 0,
              }}
            >
              <span
                style={{
                  color: themeColor,
                }}
              >
                {order.items[1]?.quantity}x{" "}
              </span>
              {showOnlyFirst20Letters(
                language === "arabic"
                  ? order.items[1]?.product.ar_name
                  : order.items[1]?.product.name
              )}
            </p>
          )}
        </div>
        <div>
          {order.items.length > 2 && (
            <p
              style={{
                fontSize: 12,
                fontWeight: 400,
                fontFamily: "Quicksand",
                margin: 0,
              }}
            >
              {showOnlyFirst20Letters(
                `+ ${order.items.length - 2} ${
                  language === "arabic" ? "منتجات اخري" : "more items"
                }`
              )}
            </p>
          )}
          <p
            style={{
              fontSize: 12,
              fontWeight: 400,
              fontFamily: "Quicksand",
              color: "#909090",
              margin: 0,
              direction: language === "arabic" ? "rtl" : "ltr",
            }}
          >
            {currencyAndTimeInfo}
          </p>
          <p
            onClick={handleReorder}
            style={{
              fontSize: 12,
              fontWeight: "bold",
              fontFamily: "Quicksand",
              color: themeColor,
              margin: 0,
              cursor: "pointer",
            }}
          >
            {language === "arabic" ? "إعادة طلب" : "Reorder"}
          </p>
        </div>
      </div>
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          flex: "0 0 40%",
        }}
      >
        <img
          src={
            order.items[0]?.product?.photo_thumb ||
            order.items[0]?.product?.photo
          }
          alt={
            language === "arabic"
              ? order.items[0]?.product.ar_name
              : order.items[0]?.product.name
          }
          style={{
            width: 80,
            height: 80,
            objectFit: "cover",
            borderRadius: 2,
          }}
        />
      </div>
    </div>
  );
};

export default PreviousOrderAgainCard;
